// Japanese translations
import { TranslationKeys } from './ko';

export const ja: TranslationKeys = {
  // 共通
  common: {
    save: '保存',
    cancel: 'キャンセル',
    confirm: '確認',
    delete: '削除',
    edit: '編集',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    loading: '読み込み中...',
    error: 'エラーが発生しました',
    success: '成功しました',
  },

  // ナビゲーション
  nav: {
    home: 'ホーム',
    restaurants: 'レストラン',
    restaurantSearch: 'レストランを探す',
    events: 'イベント',
    notices: 'お知らせ',
    community: 'コミュニティ',
    profile: 'プロフィール',
    myProfile: 'マイプロフィール',
    login: 'ログイン',
    logout: 'ログアウト',
    settings: '設定',
    menu: 'メニュー',
    search: '検索',
    searchPlaceholder: 'レストランを検索...',
  },

  // 検索
  search: {
    viewAllResults: '全ての検索結果を見る',
    noResults: '検索結果がありません',
    tryDifferent: '別のキーワードで検索してください',
    recentSearches: '最近の検索',
    clearAll: 'すべて削除',
    searchSuggestions: '検索候補',
    popularSearches: '人気の検索',
  },

  // プロフィールページ
  profile: {
    title: 'プロフィール',
    myFavorites: 'お気に入り',
    myReviews: 'レビュー',
    settings: '設定',
    editProfile: 'プロフィール編集',

    // プロフィール情報
    profileInfo: 'プロフィール情報',
    name: '名前',
    email: 'メール',
    phone: '電話番号',
    uploadImage: '画像アップロード',
    saveProfile: 'プロフィール保存',
    profilePhoto: 'プロフィール写真',
    fileTypeInfo: 'JPG、PNG ファイル (最大 5MB)',
    phonePlaceholder: '010-1234-5678',
    emailReadOnly: 'メールアドレスは変更できません',
    verified: '認証済み',
    saving: '保存中...',

    // 設定
    languageSettings: '言語設定',
    themeSettings: 'テーマ設定',
    notificationSettings: '通知設定',
    language: '言語',
    theme: 'テーマ',

    // 言語
    korean: '한국어',
    english: 'English',
    japanese: '日本語',
    chinese: '中文',

    // テーマ
    lightMode: 'ライトモード',
    darkMode: 'ダークモード',
    autoMode: 'システム設定に従う',

    // 通知
    pushNotifications: 'プッシュ通知',
    emailNotifications: 'メール通知',
    pushNotificationDesc: '新しいイベント、コメントなどの通知を受け取ります',
    emailNotificationDesc: '重要なお知らせをメールで受け取ります',

    // アカウント
    accountManagement: 'アカウント管理',
    deleteAccount: 'アカウント削除',
    cancelDeletion: '削除キャンセル',
    recoverAccount: 'アカウント復元',
    recoverAccountButton: 'アカウントを復元する',
    deletionPending: 'アカウント削除待ち',
    recoveryPeriodInfo: '30日以内にアカウントを復元できます。復元後は正常にサービスをご利用いただけます。',
    deletionWarningTitle: 'アカウント削除時の注意事項',
    deletionWarning1: '削除リクエスト後、30日間の猶予期間が提供されます。',
    deletionWarning2: '猶予期間中はログインできませんが、アカウント復元をリクエストできます。',
    deletionWarning3: '30日経過後、すべてのデータが完全に削除され、復元できません。',
    deletionWarning4: '作成したレビュー、お気に入りなど、すべての活動履歴が削除されます。',
    deletionDialogTitle: '本当に退会しますか？',
    deletionReason: '退会理由（任意）',
    deletionReasonPlaceholder: '退会理由を教えていただけると、サービス改善に役立ちます。',
    processing: '処理中...',
    withdraw: '退会する',

    // メッセージ
    profileUpdated: 'プロフィールが更新されました。',
    languageChanged: '言語設定が変更されました。',
    themeChanged: 'テーマ設定が変更されました。',
    notificationsChanged: '通知設定が更新されました。',
    imageSizeError: '画像サイズは5MB以下である必要があります。',
    imageTypeError: '画像ファイルのみアップロード可能です。',
    imageUploaded: '画像がアップロードされました。',
    imageUploadFailed: '画像のアップロードに失敗しました。',
    profileUpdateFailed: 'プロフィールの更新に失敗しました。',
    languageChangeFailed: '言語設定の変更に失敗しました。',
    themeChangeFailed: 'テーマ設定の変更に失敗しました。',
    notificationChangeFailed: '通知設定の更新に失敗しました。',
    deletionRequestComplete: 'アカウント削除がリクエストされました。30日以内に復元できます。',
    deletionRequestFailed: 'アカウント削除リクエスト中にエラーが発生しました。',
    accountRecovered: 'アカウントが正常に復元されました。',
    accountRecoveryFailed: 'アカウント復元中にエラーが発生しました。',
    memoUpdateFailed: 'メモの更新に失敗しました。',
    reviewDeleteFailed: 'レビューの削除に失敗しました。',
    reviewEditComingSoon: 'レビュー編集機能は準備中です。',
  },

  // ホーム
  home: {
    heroTitle: 'あなたの美味しい瞬間',
    heroSubtitle: '全国の隠れた名店を見つけよう',
    categories: 'カテゴリー',
    allCategories: 'すべて',
    highRatedRestaurants: '高評価レストラン',
    popularRestaurants: '人気レストラン',
    newRestaurants: '新規レストラン',
    featuredRestaurants: 'おすすめレストラン',
    mostReviewedRestaurants: 'レビューが多いレストラン',
    mostViewedRestaurants: '閲覧数が多いレストラン',
    mostLikedRestaurants: 'お気に入りが多いレストラン',
    featuredTitle: '今すぐ行きたいレストラン',
    exploreRestaurants: 'レストランを探す',
    selectedCategory: '選択されたカテゴリー',
    viewAll: 'すべて見る',
    viewMore: 'もっと見る',
    registeredRestaurants: '登録レストラン',
    writtenReviews: '投稿レビュー',
    activeUsers: 'アクティブユーザー',
  },

  // レストラン
  restaurant: {
    // レストラン検索ページ
    findTitle: 'レストランを探す',
    findSubtitle: '全国のレストランを検索・探索',
    searchPlaceholder: 'レストランを検索...',
    allCategories: 'すべてのカテゴリー',
    sort: '並び替え',
    sortByNewest: '新着順',
    sortByRating: '評価が高い順',
    sortByReviews: 'レビューが多い順',
    sortByViews: '閲覧数が多い順',
    totalCount: '全{{count}}件のレストラン',
    noResults: '検索結果が見つかりません。別の検索語を試してください。',

    // レストラン詳細ページ
    reviews: 'レビュー',
    tags: 'タグ',
    info: '情報',
    address: '住所',
    phone: '電話番号',
    website: 'ウェブサイト',
    hours: '営業時間',
    facilities: '施設',
    services: 'サービス',
    menu: 'メニュー',
    photos: '写真',
    rating: '評価',
    reviewCount: 'レビュー',
    viewCount: '閲覧数',
    priceRange: '価格帯',
    avgPrice: '1人平均',
    parking: '駐車場',
    reservation: '予約',
    delivery: '配達',
    takeout: 'テイクアウト',
    contact: '連絡先',
    operations: '営業情報',
    copyAddress: '住所をコピー',
    showOnMap: '地図で見る',
    share: '共有',
    favorite: 'お気に入りに追加',
    unfavorite: 'お気に入りから削除',
    addReview: 'レビューを書く',
    map: '地図',

    // SNS / リンク
    blog: 'ブログ',
    instagram: 'Instagram',
    facebook: 'Facebook',
    youtube: 'YouTube',
    kakao: 'カカオトーク',
    naverPlace: 'Naver Place',
    booking: '予約',
    naverBooking: 'Naver予約',

    // 営業時間
    noHoursInfo: '営業時間情報がありません。',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土',
    sun: '日',
    noInfo: '情報なし',
    closed: '休業',
    breakTime: 'ブレイクタイム',
    lastOrder: 'ラストオーダー',
    regularHolidays: '定休日',
    holidayNotice: '休業案内',

    // 施設 / サービス
    parkingFacilities: '駐車施設',
    amenities: '便利施設',
    seatingInfo: '座席情報',
    reservationService: '予約サービス',
    kidsMenu: 'キッズメニュー',
    reservationPhone: '予約電話',

    // メニュータイプ
    signatureMenu: 'シグニチャーメニュー',
    popularMenu: '人気メニュー',
    allMenu: '全メニュー',
    newMenu: '新メニュー',
    seasonalMenu: 'シーズン限定',
    signature: 'シグニチャー',
    noMenuInfo: '登録されたメニューがありません。',

    // レビュー
    firstReview: '最初のレビューを書いてみましょう！',
  },

  // イベント
  event: {
    title: 'イベント',
    ongoing: '開催中',
    ended: '終了',
    viewDetail: '詳細を見る',
    period: '期間',
    noEvents: '開催中のイベントはありません',
  },

  // お知らせ
  notice: {
    title: 'お知らせ',
    important: '重要',
    viewDetail: '詳細を見る',
    noNotices: 'お知らせはありません',
    postedAt: '投稿日',
  },

  // 利用規約
  terms: {
    title: '利用規約',
    legalNotice: '法的効力について',
    legalNoticeContent: '本利用規約は韓国語版のみが法的効力を持ちます。他の言語への翻訳は参考用であり、韓国語原文と相違がある場合は韓国語原文が優先されます。',
  },

  // プライバシーポリシー
  privacy: {
    title: 'プライバシーポリシー',
    legalNotice: '法的効力について',
    legalNoticeContent: '本プライバシーポリシーは韓国語版のみが法的効力を持ちます。他の言語への翻訳は参考用であり、韓国語原文と相違がある場合は韓国語原文が優先されます。',
  },

  // レビュー
  review: {
    writeReview: 'レビューを書く',
    editReview: 'レビューを編集',
    deleteReview: 'レビューを削除',
    title: 'タイトル',
    content: '内容',
    rating: '評価',
    anonymous: '匿名で投稿',
    submit: '投稿',
    minLength: 'レビューは10文字以上で入力してください。',
  },

  // フッター
  footer: {
    companyName: 'MZCube',
    description: '全国の隠れた名店をご紹介します。\nあなたの美味しい瞬間を共有しましょう。',
    quickLinks: 'クイックリンク',
    policies: 'ポリシー',
    companyInfo: '会社情報',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    contact: 'お問い合わせ',
    businessName: '屋号',
    businessNumber: '事業者登録番号',
    address: '所在地',
    adminEmail: '管理者メール',
    notYetRegistered: '未登録（登録予定）',
    copyright: '© 2025 MZCube. All rights reserved.',
  },

  // お問い合わせページ
  contactPage: {
    title: 'お問い合わせ',
    subtitle: 'ご質問や問題がございますか？いつでもお問い合わせください。',
    quickContact: '簡単なお問い合わせ',
    emailContact: 'メールでお問い合わせ',
    kakaoContact: 'カカオトークでお問い合わせ',
    emailContactDescription: '管理者メールに直接お問い合わせ',
    kakaoContactDescription: 'カカオトークチャンネルでお問い合わせ',
    sendEmail: 'メールを送る',
    openKakao: 'カカオトークを開く',
    directContact: 'サイト内お問い合わせ',
    directContactDescription: '下記のフォームに記入していただければ、管理者が迅速に確認して回答いたします。',
    name: '名前',
    namePlaceholder: '名前を入力してください',
    email: 'メール',
    emailPlaceholder: '返信用メールアドレスを入力してください',
    subject: '件名',
    subjectPlaceholder: 'お問い合わせ件名を入力してください',
    message: 'お問い合わせ内容',
    messagePlaceholder: 'お問い合わせ内容を詳しく記入してください',
    submit: 'お問い合わせ',
    sending: '送信中...',
    successMessage: 'お問い合わせが正常に送信されました。できるだけ早く回答いたします。',
    errorMessage: 'お問い合わせの送信に失敗しました。もう一度お試しください。',
    requiredField: '必須項目です',
    invalidEmail: '正しいメールアドレスを入力してください',
  },

  // コミュニティ
  community: {
    title: 'コミュニティ',
    subtitle: '自分だけのレストランコレクションを作成して共有しましょう',
    popular: '人気コレクション',
    latest: '最新コレクション',
    following: 'フォロー中',
    myCollections: 'マイコレクション',
    createCollection: 'コレクションを作成',
    editCollection: 'コレクションを編集',
    deleteCollection: 'コレクションを削除',
    collectionName: 'コレクション名',
    collectionDescription: '説明',
    visibility: '公開設定',
    public: '公開',
    private: '非公開',
    followersOnly: 'フォロワーのみ',
    items: '件のレストラン',
    likes: 'いいね',
    saves: '保存',
    comments: 'コメント',
    views: '閲覧数',
    addToCollection: 'コレクションに追加',
    removeFromCollection: 'コレクションから削除',
    addNote: 'メモを追加',
    noCollections: 'コレクションがありません',
    noCollectionsDesc: '最初のコレクションを作成しましょう！',
    collectionCreated: 'コレクションが作成されました',
    collectionUpdated: 'コレクションが更新されました',
    collectionDeleted: 'コレクションが削除されました',
    follow: 'フォロー',
    following_btn: 'フォロー中',
    unfollow: 'フォロー解除',
    followers: 'フォロワー',
    writeComment: 'コメントを入力',
    deleteConfirm: '本当に削除しますか？',
    loginRequired: 'ログインが必要です',
    coverImage: 'カバー画像',
    selectCoverImage: 'カバー画像を選択',
    restaurantCount: '{{count}}件のレストラン',
    emptyCollection: 'まだレストランがありません',
    addRestaurants: 'レストランを追加',
    sortByLatest: '新着順',
    sortByPopular: '人気順',
    sortByLikes: 'いいね順',
  },
};
